import { openNotification } from "../components/notifications";
import apiClient from "./ApiInterceptor";

export const fetchUser = async (userId) => {
    try {
        const response = await apiClient.get(`/users/${userId}`);
        return response.data;
    } catch (error) {
        openNotification(
            "error",
            "Error cargando los usuarios",
            error.response?.data?.message
        );
        // TODO: change to log instead of console.error
        console.error('UsersApi - fetchAllUsers, Error fetching data:', error);
        return [];
    }
}

export const fetchUserNames= async (userId) => {
    const response = await apiClient.get(`/users/${userId}/names`);
    return response.data;
}

export const fetchAllUsers = async (params = {}) => {
    try {
        const response = await apiClient.get('/users', { params });
        return response.data;
    } catch (error) {
        openNotification(
            "error",
            "Error cargando los usuarios",
            error.response?.data?.message
        );
        // TODO: change to log instead of console.error
        console.error('UsersApi - fetchAllUsers, Error fetching data:', error);
        return { items: [], total: 0 };
    }
};

export const fetchActiveUsers = async (params = {}) => {
    try {
        const response = await apiClient.get('/users/active', { params });
        return response.data;
    } catch (error) {
        openNotification(
            "error",
            "Error cargando los usuarios activos",
            error.response?.data?.message
        );
        // TODO: change to log instead of console.error
        console.error('UsersApi - fetchActiveUsers, Error fetching data:', error);
        return { items: [], total: 0 };
    }
};

export const fetchExpiredUsers = async (params = {}) => {
    try {
        const response = await apiClient.get('/users/expired', { params });
        return response.data;
    } catch (error) {
        openNotification(
            "error",
            "Error cargando los usuarios expirados",
            error.response?.data?.message
        );
        // TODO: change to log instead of console.error
        console.error('UsersApi - fetchExpiredUsers, Error fetching data:', error);
        return { items: [], total: 0 };
    }
};

export const fetchAgreementsUsers = async (params = {}) => {
    try {
        const response = await apiClient.get('/users/agreements', { params });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('UsersApi - fetchAgreementsUsers, Error fetching Show Stars Users:', error);
        return { success: false, error };
    }
}

export const fetchUsersCounts = async () => {
    try {
        const response = await apiClient.get('/users/counts');
        return response.data;
    } catch (error) {
        console.error('UsersApi - fetchUsersCounts, Error:', error);
        return { active: 0, expired: 0, all: 0, agreements: 0 };
    }
}

export const fetchNewUsers = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/users/new', {params})
    return retention;
};

export const patchFollowUp = async (user_id, params) => {
    const response = await apiClient.patch(`/users/${user_id}/follow-up`, params);
    return response;
}

export const patchUser = async (user_id, params) => {
    try {
        const response = await apiClient.patch(`/users/${user_id}`, params);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('UsersApi - patchUser, Error updating user:', error);
        return { success: false, error };
    }
};